import { MyMessage } from './../../../_models/message';
import { MessageService } from './../../../_services/message.service';
import { AuthService } from './../../../_services/auth.service';
import { Router } from '@angular/router';

import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-student-message-create',
  templateUrl: './student-message-create.component.html',
  styleUrls: ['./student-message-create.component.css']
})
export class StudentMessageCreateComponent implements OnInit {
  message= new MyMessage(0,"","",0)
  user_id=0
  myForm = new FormGroup({
    toUser: new FormControl('', [Validators.required]),
    title: new FormControl('', [Validators.required]),
    body: new FormControl('', [Validators.required]),
  });

  toUserOptions=[]
  errorSaving = false
  constructor(
    private authService:AuthService,
    private messageService:MessageService,
    private router:Router) { }
  get f() {
    return this.myForm.controls;
  }

  ngOnInit(): void {
    this.user_id=this.authService.gatePass.getValue().user_id
    this.errorSaving=false
    this.messageService.getToUserOptions(this.user_id).subscribe(
      val=>{
        this.toUserOptions=val
      }
    )
  }


  submit() {
   let dd= this.formatData(
     this.myForm.value.toUser,
     this.myForm.value.title,
     this.myForm.value.body
     )
    this.messageService.sendMessage(dd).subscribe(
      x=>{
        let id=x['id']
        if(id==0){
          this.errorSaving=true
        }else{
          this.router.navigate(['/student/messaging/home',this.user_id])
        }
      }
    )
  }
  formatData(to:string, title:string,body:string){
    let data = new URLSearchParams();
    data.set('toUser', to);
    data.set('title', title);
    data.set('fromUserId', this.user_id.toString());
    data.set('body', body);
    return data.toString()
  }
  get diagnostic() { return JSON.stringify(this.message); }
}
